import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, PIMSEnvironment } from "environments";
import { Observable } from "rxjs";
import { State } from "../../types/misc";

@Injectable({
  providedIn: 'root'
})
export class BusinessService {
	private http = inject(HttpClient);

	private env = inject<PIMSEnvironment>(ENVIRONMENT)

	getAllRoles() {
		return this.http.get(`${this.env.constants.ADMIN_API_URL}/admin/users/roles`);
	}

	getAllStates():Observable<State[]> {
		return this.http.get(`${this.env.constants.ADMIN_API_URL}/admin/states`) as Observable<State[]>
	}
}
